import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled, alpha } from '@mui/material/styles';
import i18n from '../../_locales/i18n';
import { supportedLanguages } from '../../_locales/i18n';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const LanguageSelector = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleChangeLanguage = (e) => {
    const language = e.target.getAttribute('data-language');
    localStorage.setItem('FRM_LOCALE', language);
    // console.log(i18n.languages);
    i18n.changeLanguage(language);
    // console.log(i18n.locales);
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const StyledLanguageMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 130,
      color:
        theme.palette.mode === 'light'
          ? 'rgb(55, 65, 81)'
          : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  return (
    <div>
      <Button
        id="language-change-button"
        size="medium"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        startIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M12 22.5C10.6333 22.5 9.34167 22.2373 8.125 21.712C6.90833 21.1867 5.84567 20.47 4.937 19.562C4.029 18.654 3.31233 17.5917 2.787 16.375C2.26167 15.1583 1.99933 13.8667 2 12.5C2 11.1167 2.26267 9.82067 2.788 8.612C3.31333 7.40333 4.03 6.34533 4.938 5.438C5.846 4.52933 6.908 3.81267 8.124 3.288C9.34 2.76333 10.632 2.50067 12 2.5C13.3833 2.5 14.6793 2.76267 15.888 3.288C17.0967 3.81333 18.1547 4.53 19.062 5.438C19.9707 6.346 20.6873 7.40433 21.212 8.613C21.7367 9.82167 21.9993 11.1173 22 12.5C22 13.8667 21.7373 15.1583 21.212 16.375C20.6867 17.5917 19.97 18.6543 19.062 19.563C18.154 20.471 17.0957 21.1877 15.887 21.713C14.6783 22.2383 13.3827 22.5007 12 22.5ZM12 20.45C12.4333 19.85 12.8083 19.225 13.125 18.575C13.4417 17.925 13.7 17.2333 13.9 16.5H10.1C10.3 17.2333 10.5583 17.925 10.875 18.575C11.1917 19.225 11.5667 19.85 12 20.45ZM9.4 20.05C9.1 19.5 8.83734 18.929 8.612 18.337C8.38667 17.745 8.19934 17.1327 8.05 16.5H5.1C5.58333 17.3333 6.18767 18.0583 6.913 18.675C7.63833 19.2917 8.46733 19.75 9.4 20.05ZM14.6 20.05C15.5333 19.75 16.3627 19.2917 17.088 18.675C17.8133 18.0583 18.4173 17.3333 18.9 16.5H15.95C15.8 17.1333 15.6127 17.746 15.388 18.338C15.1633 18.93 14.9007 19.5007 14.6 20.05ZM4.25 14.5H7.65C7.6 14.1667 7.56234 13.8373 7.537 13.512C7.51167 13.1867 7.49933 12.8493 7.5 12.5C7.5 12.15 7.51267 11.8127 7.538 11.488C7.56333 11.1633 7.60067 10.834 7.65 10.5H4.25C4.16667 10.8333 4.104 11.1627 4.062 11.488C4.02 11.8133 3.99933 12.1507 4 12.5C4 12.85 4.021 13.1873 4.063 13.512C4.105 13.8367 4.16733 14.166 4.25 14.5ZM9.65 14.5H14.35C14.4 14.1667 14.4377 13.8373 14.463 13.512C14.4883 13.1867 14.5007 12.8493 14.5 12.5C14.5 12.15 14.4873 11.8127 14.462 11.488C14.4367 11.1633 14.3993 10.834 14.35 10.5H9.65C9.6 10.8333 9.56233 11.1627 9.537 11.488C9.51167 11.8133 9.49933 12.1507 9.5 12.5C9.5 12.85 9.51267 13.1873 9.538 13.512C9.56333 13.8367 9.60067 14.166 9.65 14.5ZM16.35 14.5H19.75C19.8333 14.1667 19.896 13.8373 19.938 13.512C19.98 13.1867 20.0007 12.8493 20 12.5C20 12.15 19.979 11.8127 19.937 11.488C19.895 11.1633 19.8327 10.834 19.75 10.5H16.35C16.4 10.8333 16.4377 11.1627 16.463 11.488C16.4883 11.8133 16.5007 12.1507 16.5 12.5C16.5 12.85 16.4873 13.1873 16.462 13.512C16.4367 13.8367 16.3993 14.166 16.35 14.5ZM15.95 8.5H18.9C18.4167 7.66667 17.8127 6.94167 17.088 6.325C16.3633 5.70833 15.534 5.25 14.6 4.95C14.9 5.5 15.1627 6.071 15.388 6.663C15.6133 7.255 15.8007 7.86733 15.95 8.5ZM10.1 8.5H13.9C13.7 7.76667 13.4417 7.075 13.125 6.425C12.8083 5.775 12.4333 5.15 12 4.55C11.5667 5.15 11.1917 5.775 10.875 6.425C10.5583 7.075 10.3 7.76667 10.1 8.5ZM5.1 8.5H8.05C8.2 7.86667 8.38767 7.254 8.613 6.662C8.83833 6.07 9.10067 5.49933 9.4 4.95C8.46667 5.25 7.63733 5.70833 6.912 6.325C6.18667 6.94167 5.58267 7.66667 5.1 8.5Z"
              fill="white"
            />
          </svg>
        }
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          'border-radius': '88px',
          background: '#0052CC',
          fontSize: '14px',
        }}
      >
        {t(`${i18n.language}`)}
      </Button>
      <StyledLanguageMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {supportedLanguages.map((language) => {
          return (
            <MenuItem
              key={language}
              onClick={handleChangeLanguage}
              data-language={language}
              disableRipple
              sx={{
                fontSize: '16px',
              }}
            >
              {t(`${language}`)}
            </MenuItem>
          );
        })}
      </StyledLanguageMenu>
    </div>
  );
};
